var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-sort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Desktop---Contact-Details-(List)",
    transform: "translate(-991.000000, -161.000000)",
    fill: "#067BC2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(40.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Copy",
    transform: "translate(944.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3901342,13.3632887 L23.0621129,14.6340644 C22.7747053,14.9058592 22.3161145,14.7024631 22.3161145,14.3073707 L22.3161145,0.900327239 C22.3161145,0.403536746 21.8980671,0.000344462259 21.4007348,0.000344462259 L21.4079425,0.000344462259 C20.9106103,0.000344462259 20.514186,0.403536746 20.514186,0.900327239 L20.514186,14.2938709 C20.514186,14.6907633 20.0222596,14.8932595 19.7366539,14.6178647 L18.4194442,13.3542889 C18.0608604,13.0122955 17.4869462,13.0275952 17.1481837,13.3902882 L17.1436788,13.3920882 C16.8085201,13.7502813 16.8256385,14.3127706 17.1824203,14.6493641 L20.1898389,17.5086094 C20.8862843,18.1664968 21.976451,18.1628969 22.6701934,17.5023095 L25.6235542,14.6682638 C25.9767322,14.3316702 25.9938505,13.7745809 25.6613947,13.4172877 L25.652385,13.4082879 C25.3163254,13.0464948 24.7505198,13.0266952 24.3901342,13.3632887 M7.247577,4.59205659 L7.23856874,4.58305676 C6.9061639,4.2257636 6.92327959,3.66867426 7.27640344,3.3320807 L10.2293115,0.498034938 C10.9229477,-0.163452403 12.0129473,-0.166152351 12.7101867,0.490835076 L15.7171444,3.35098034 C16.0738716,3.6875739 16.0918881,4.24916315 15.7567808,4.6073563 L15.7540783,4.61005625 C15.4153676,4.9727493 14.8451447,4.98804901 14.4866159,4.64515557 L13.1777155,3.38247974 C12.8912528,3.10708501 12.4138149,3.30958113 12.4138149,3.70647354 L12.4138149,17.1000172 C12.4138149,17.5968077 12.0111457,18 11.5129888,18 C11.0157328,18 10.6121627,17.5968077 10.6121627,17.1000172 L10.6121627,3.6929738 C10.6121627,3.29788136 10.1392289,3.09448525 9.85186539,3.36628005 L8.50963443,4.63705573 C8.14930397,4.97364929 7.58358516,4.95384967 7.247577,4.59205659",
    id: "icon-sort"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon_sort.76c2c27661037d6657849664248fbd78.svg";
export { ForwardRef as ReactComponent };